import React, { ComponentProps } from "react";
import { Select, SelectChangeEvent, MenuItem } from "@mui/material";

export type DSEnumSelectOption<T extends string> = {
  value: T;
  label: string;
};

type DSEnumSelectProps<T extends string> = {
  value: T;
  options: DSEnumSelectOption<T>[];
  onChange: (value: T) => void;
} & Omit<ComponentProps<typeof Select>, "value" | "onChange" | "children">;

const DSEnumSelect = <T extends string>({
  value,
  options,
  onChange,
  ...selectProps
}: DSEnumSelectProps<T>) => {
  return (
    <Select
      value={value}
      onChange={(e: SelectChangeEvent<unknown>) =>
        onChange(e.target.value as T)
      }
      {...selectProps}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DSEnumSelect;
